<template>
    <v-dialog v-model="dialog" max-width="780" v-resize="onResize" persistent>
        <v-card class="plan-save-budget-card font-theme">
            <v-form ref="planSaveModal" lazy-validation>
                <v-row no-gutters class="standard-row" align="center">
                    <a class="ml-4 pt-4" @click="backToSaveBudgetModal()">
                        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 10.9653L1 5.98267L5 1" stroke="#2A2E3B" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span style="font-size: 14px;" class="ml-2 black--text">ย้อนกลับ</span>
                    </a>
                </v-row>
                <div class="scroll-theme plan-save-budget-for-scroll-mobile py-4">
                    <v-row no-gutters class="standard-row plan-save-budget-header-modal" align="center">
                        <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.9554 4.30078H4.06321C2.37145 4.30078 1 5.74508 1 7.52671V22.044C1 23.8256 2.37145 25.2699 4.06321 25.2699H19.3793C21.0711 25.2699 22.4425 23.8256 22.4425 22.044V14.785" stroke="#2A2E3B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4431 2.63326C23.293 3.55814 23.2815 5.02993 22.4173 5.94003L11.7218 17.2037L7.12698 18.8166L8.65858 13.9778L19.3606 2.6134C20.1997 1.72236 21.5658 1.71639 22.4119 2.60007C22.4224 2.61102 22.4328 2.62209 22.4431 2.63326Z" stroke="#2A2E3B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.3789 5.91406L20.8385 7.52703" stroke="#2A2E3B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span style="font-weight: 700; font-size: 28px;" class="ml-4 pt-2 black--text">
                            Plan
                        </span>
                    </v-row>
                    <v-row no-gutters class="standard-row" style="padding: 25px 2.307% 0px 16px;">
                        <v-col cols="12">
                            <v-row no-gutters class="standard-row">
                                <v-col cols="6" sm="6" md="6" lg="3" class="pl-4 black--text font-size-16 mb-2">
                                    จำนวนเงินที่บันทึก
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="2">
                                    <v-row no-gutters class="standard-row input-plan-save-budget-modal d-flex justify-center" align="center">{{ saveBudgetData.net}}</v-row>
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="auto" class="pl-4 pr-4 black--text font-size-16 mb-2">
                                    ส่วนลด
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="2">
                                    <v-text-field class="slim centered-input"  v-if="actionStatus === 'edit' && !this.saveBudgetData.is_product_discount" no-gutters height="24" v-model="saveBudgetData.discount" v-currency="{ distractionFree: false, currency: null, allowNegative: false }" hide-details outlined align="center" @keyup="changeNet(saveBudgetData.discount)" ></v-text-field>
                                     <v-row v-else no-gutters class="standard-row input-plan-save-budget-modal d-flex justify-center" align="center">{{ saveBudgetData.discount }}</v-row>
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="auto" class="pl-4 pr-4 black--text font-size-16 mb-2">
                                    สุทธิ
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="2">
                                    <!-- <v-text-field class="slim centered-input" v-if="actionStatus === 'edit'" no-gutters height="24" readonly filled v-model="saveBudgetData.net" align="center" hide-details outlined></v-text-field> -->
                                    <v-row no-gutters class="standard-row input-plan-save-budget-modal d-flex justify-center" align="center">{{ saveBudgetData.net }}</v-row>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="standard-row">
                                <v-col cols="6" sm="6" md="6" lg="3" class="pl-4 black--text font-size-16 mb-2">
                                    วันที่เริ่มต้น
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="2">
                                    <v-row no-gutters class="standard-row input-plan-save-budget-modal d-flex justify-center" align="center">{{ startDateTextShow }}</v-row>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="standard-row">
                                <v-col cols="6" sm="6" md="6" lg="3" class="pl-4 black--text font-size-16 mb-2">
                                    วันที่สิ้นสุด
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="2">
                                    <v-row no-gutters class="standard-row input-plan-save-budget-modal d-flex justify-center" align="center">{{ endDateTextShow }}</v-row>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="standard-row mb-n2">
                                <v-col cols="6" sm="6" md="6" lg="3" class="pl-4 black--text font-size-16 mb-2">
                                    จำนวนรายการ
                                </v-col>
                                <v-col cols="6" sm="6" md="6" lg="2">
                                    <v-row no-gutters class="standard-row input-plan-save-budget-modal d-flex justify-center" align="center">{{ planBudgetPeriod?.length || '0' }}</v-row>
                                </v-col>
                                <template v-if="(saveBudgetData.document_status === 'W' && saveBudgetData.document_status_permission !== 'Y')">
                                <v-col v-if="actionStatus === 'success'" cols="12" sm="auto" md="auto" lg="auto" class="mt-5 mt-sm-0 d-flex align-end ml-auto mb-2">
                                    <template>
                                        <v-btn height="30" width="84" color="#0B68D6" @click="editBudget()" style="border-radius: 6px; font-size: 15px; font-weight: 700; letter-spacing: 1px; box-shadow: none;" class="font-theme white--text">
                                            แก้ไข
                                        </v-btn>
                                    </template>
                                </v-col>
                                <v-col v-else cols="12" sm="auto" md="auto" lg="auto" class="mt-5 mt-sm-0 d-flex align-end d-flex ml-auto mb-2">
                                    <template>
                                        <v-btn height="30" width="84" color="#FF0000" @click="cancelEdit()" style="border-radius: 6px; font-size: 15px; font-weight: 700; letter-spacing: 1px; box-shadow: none;" class="font-theme white--text">
                                            ยกเลิก
                                        </v-btn>
                                        <v-btn height="30" width="84" color="#0B68D6" @click="confirmEdit()" style="border-radius: 6px; font-size: 15px; font-weight: 700; letter-spacing: 1px; box-shadow: none;" class="font-theme white--text ml-3">
                                            ยืนยัน
                                        </v-btn>
                                    </template>
                                </v-col>
                                </template>
                            </v-row>
                        <!-- <v-spacer></v-spacer> -->

                        </v-col>
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme mt-4" style="padding: 0px 2.307%;" align="center">
                        <v-data-table :headers="planBudget" :items="planBudgetPeriod" options.sync="{ page: 1 }" :server-items-length="planBudgetPeriod.length" fixed-header hide-default-footer class="elevation-0 plan-save-budget-modal-data-table">
                            <template v-if="planBudgetPeriod.length < 10" v-slot:body.append="{ isMobile }">
                                <tr v-for="(_, index_tr) in (10 - planBudgetPeriod.length)" :key="`tr__${index_tr}`" v-show="!isMobile">
                                    <td v-for="(_, index_td) in 4" :key="`td__${index_td}`"></td>
                                </tr>
                            </template>
                            <template v-if="actionStatus === 'edit'" v-slot:item.amount="props">
                                <v-text-field height="20" hide-details outlined v-model="props.item.amount" v-currency="{ distractionFree: false, currency: null, allowNegative: false }" :rules="[ v => !!v ]" required color="black" class="text-field-plan-save-budget-table text-center"></v-text-field>
                            </template>
                        </v-data-table>
                    </v-row>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
export default {
    data: () => ({
        planBudget: [
            { text: 'งวดที่'         , value: 'no'       , align: 'center', sortable: false, width: '20%' },
            { text: 'รายละเอียด'     , value: 'month_th' , align: 'center', sortable: false, width: '30%' },
            { text: 'สัดส่วน(%)'     , value: 'percent'  , align: 'center', sortable: false, width: '20%' },
            { text: 'จำนวนเงิน(บาท)', value: 'amount'   , align: 'center', sortable: false, width: '30%' },
        ],
        dialog: false,
        isPlanEmpty:'',
        countTotalDays: 0,
        saveBudgetData: {},
        windowSize: { x: 0 },
        planBudgetPeriod: [],
        actionStatus: 'success',
        planBudgetPeriodCount: [],
        discount: 0,
        net: 0
    }),
    mounted() {
        this.onResize()
        EventBus.$on('planSaveBudgetModal', this.openDialog)
    },
    beforeDestroy() {
        EventBus.$off('planSaveBudgetModal')
    },
    computed: {
        startDateTextShow() {
            return MainFunction.shortDate(this.saveBudgetData.start_date || null)
        },
        endDateTextShow() {
            return MainFunction.shortDate(this.saveBudgetData.end_date || null)
        }
    },
    methods: {
        openDialog(data) {
            if (!Object.keys(data).length) {
                return
            }
            if (data.period.length && (data.save_budget_id || (this.saveBudgetData.start_date === data.start_date && this.saveBudgetData.end_date === data.end_date))) {
                this.saveBudgetData   = data
                this.planBudgetPeriod = structuredClone(data.period)
            } else {
                this.saveBudgetData   = data
                this.planBudgetPeriod = this.calculatePeriod(data.start_date, data.end_date, parseFloat(data.saved_budget?.replace(/,/g, '') || '0'))
            }
            this.planBudgetPeriodCount = structuredClone(this.planBudgetPeriod)
            this.dialog                = true
            this.discountPeriod = data.discount
            this.netPeriod = data.net
        },
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        calculatePeriod(start_date = null, end_date = null) {
            let index            = 1
            let result           = []
            this.countTotalDays  = 0
            const months = [
                { en: "january"  , th: "มกราคม" },
                { en: "february" , th: "กุมภาพันธ์" },
                { en: "march"    , th: "มีนาคม" },
                { en: "april"    , th: "เมษายน" },
                { en: "may"      , th: "พฤษภาคม" },
                { en: "june"     , th: "มิถุนายน" },
                { en: "july"     , th: "กรกฎาคม" },
                { en: "august"   , th: "สิงหาคม" },
                { en: "september", th: "กันยายน" },
                { en: "october"  , th: "ตุลาคม" },
                { en: "november" , th: "พฤศจิกายน" },
                { en: "december" , th: "ธันวาคม" }
            ]
            const endDate   = new Date(end_date)
            let currentDate = new Date(new Date(start_date))
            while (currentDate <= endDate) {
                const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
                const findMonth = currentDate.getMonth()
                const amountDays = Math.min(
                    Math.ceil((lastDayOfMonth - currentDate) / (1000 * 60 * 60 * 24)) + 1,
                    `${new Date(start_date).getMonth() + 1}${new Date(start_date).getFullYear()}` === `${new Date(currentDate).getMonth() + 1}${new Date(currentDate).getFullYear()}`? Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24)) + 1 : Math.ceil((endDate - currentDate) / (1000 * 60 * 60 * 24))
                )
                const timePeriodCut = {
                    "no"         : index,
                    "end_date"   : this.formatShortDate(lastDayOfMonth),
                    "start_date" : this.formatShortDate(currentDate),
                    "month"      : months[findMonth].en,
                    "month_th"   : months[findMonth].th,
                    "amount_day" : amountDays
                }
                result.push(timePeriodCut)
                this.countTotalDays += amountDays
                currentDate         = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
                index++
            }
            result[result.length - 1].end_date = this.formatShortDate(endDate)
            result = this.divideBudget(result, (result.length - 1), 'average')
            return result
        },
        divideBudget(plan_budget, sweep_index = (plan_budget.length - 1), type = 'average') {
            if (!plan_budget.length) {
                return this.alert('คำนวณงบประมาณไม่สำเร็จ', 'Warning', 'info')
            }
            let tempSweepPercent     = 0
            let tempSweepAmount      = 0
            const budget             = this.saveBudgetData.net ? parseFloat(this.saveBudgetData.net?.replace(/,/g, '') || '0') : parseFloat(this.saveBudgetData.saved_budget?.replace(/,/g, '') || '0')
            if (!budget || budget === 0 || this.countTotalDays === 0) {
                plan_budget.forEach(item => {
                    item.percent = '0.00'
                    item.amount = '0.00'
                })
                return plan_budget
            }
            const divideBudgetPerDay = budget / this.countTotalDays
            for (let i = 0; i < plan_budget.length; i++) {
                if (type === 'average') {
                    const amountDay = parseFloat(plan_budget[i].amount_day || 0)
                    const tempAmountEachPeriod = divideBudgetPerDay * amountDay
                    const tempPercent = (tempAmountEachPeriod * 100) / budget
                    if (i === sweep_index) {
                        plan_budget[i].percent = (100 - tempSweepPercent).toFixed(2)
                        plan_budget[i].amount  = MainFunction.addComma(parseFloat((budget - tempSweepAmount).toFixed(2)))
                    } else {
                        plan_budget[i].amount  = MainFunction.addComma(parseFloat(tempAmountEachPeriod.toFixed(2)))
                        plan_budget[i].percent = tempPercent.toFixed(2)
                        tempSweepPercent += parseFloat(tempPercent.toFixed(2))
                        tempSweepAmount  += parseFloat(tempAmountEachPeriod.toFixed(2))
                    }
                } else {
                    const amount = parseFloat(plan_budget[i].amount?.replace(/,/g, '') || '0')
                    if (i === sweep_index) {
                        plan_budget[i].percent = (100 - tempSweepPercent).toFixed(2)
                    } else {
                        const tempPercent = (amount * 100) / budget
                        plan_budget[i].percent = tempPercent.toFixed(2)
                        tempSweepPercent += parseFloat(tempPercent.toFixed(2))
                    }
                }
            }
            return plan_budget
        },
        formatShortDate(date) {
            const year  = date.getFullYear()
            const day   = date.getDate().toString().padStart(2, '0')
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        confirmEdit() {
            let tempCountEachBudget     = false
            let checkLastIndexHasBudget = null
            for (let i = 0; i < this.planBudgetPeriod.length; i++) {
                tempCountEachBudget += parseFloat(this.planBudgetPeriod[i].amount?.replace(/,/g, '') || '0')
                if (this.planBudgetPeriod[i].amount !== '0.00') {
                    checkLastIndexHasBudget = i
                }
            }
            if (parseFloat(this.saveBudgetData.net?.replace(/,/g, '') || 0) < 0) return this.alert('จำนวนเงินสุทธิไม่ถูกต้อง', 'Warning', 'info')
            if (parseFloat(tempCountEachBudget.toFixed(2)) !== parseFloat(this.saveBudgetData.net?.replace(/,/g, '') || '0')) {
                return this.alert('จำนวนเงินรวมทั้งหมดไม่เท่ากับรายการที่บันทึก', 'Warning', 'info')
            }
            if (!this.$refs.planSaveModal.validate()) {
                return this.alert('กรอกจำนวนเงินให้ครบทุกช่อง', 'Warning', 'info')
            }
            this.planBudgetPeriod      = this.divideBudget(this.planBudgetPeriod, checkLastIndexHasBudget, 'custom')
            this.planBudgetPeriodCount = structuredClone(this.planBudgetPeriod)
            this.discountPeriod = this.saveBudgetData.discount
            this.netPeriod = this.saveBudgetData.net
            this.actionStatus          = 'success'
        },
        cancelEdit() {
            this.planBudgetPeriod = structuredClone(this.planBudgetPeriodCount)
            this.saveBudgetData.discount = this.discountPeriod
            this.saveBudgetData.net = this.netPeriod
            this.actionStatus     = 'success'
            this.$refs.planSaveModal.resetValidation()
        },
        editBudget() {
            for (let i = 0; i < this.planBudgetPeriod.length; i++) {
                this.planBudgetPeriod[i].percent = 0
            }
            this.actionStatus = 'edit'
        },
        backToSaveBudgetModal() {
            if (this.actionStatus === 'edit') {
                this.planBudgetPeriod = structuredClone(this.planBudgetPeriodCount)
                this.saveBudgetData.discount = this.discountPeriod
                this.saveBudgetData.net = this.netPeriod
                this.actionStatus     = 'success'
            }
            for (let i = 0; i < this.planBudgetPeriod.length; i++) {
                this.planBudgetPeriod[i].amount = this.planBudgetPeriod[i].amount.replace(/,/g, '')
            } 
                this.isPlanEmpty = 'isPlanEmpty'
            const tempPlanSaveBudgetData = {
                "period"             : this.planBudgetPeriod,
                "index"              : this.saveBudgetData.index,
                "discount"           : this.saveBudgetData.discount,
                "net"                : this.saveBudgetData.net,
                "is_plan_empty"      : this.isPlanEmpty
            }
            this.dialog = false
            EventBus.$emit('afterPlanSaveBudget', tempPlanSaveBudgetData)
        },
        alert(title = '', text = '', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        },
        changeNet() {
            this.saveBudgetData.net = MainFunction.addComma(((Number(this.saveBudgetData.saved_budget?.replace(/,/g, '')) || '0') - (Number(this.saveBudgetData.discount?.replace(/,/g, '') || '0'))).toFixed(2))
            if(this.saveBudgetData.net === 'NaN') this.saveBudgetData.net = MainFunction.addComma(Number(this.saveBudgetData.saved_budget?.replace(/,/g, '')).toFixed(2) || '0')
            this.planBudgetPeriod = this.calculatePeriod(this.saveBudgetData.start_date, this.saveBudgetData.end_date)
        }
    }
}
</script>

<style>
    .plan-save-budget-card {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
        border-radius: 20px !important;
    }

    .plan-save-budget-header-modal {
        padding-left: 48px;
    }

    .input-plan-save-budget-modal {
        border-radius: 5px;
        font-size: 16px;
        font-weight: 500;
        background-color: #F5F5F5;
        height: 24px;
    }

    .plan-save-budget-modal-data-table {
        width: 100%;
        overflow-y: auto;
    }

    .plan-save-budget-modal-data-table tr:hover:nth-of-type(even) {
        background-color: #F5F5F5 !important;
    }

    .plan-save-budget-modal-data-table tr:hover:nth-of-type(odd) {
        background-color: #ffffff !important;
    }

    .plan-save-budget-modal-data-table thead th {
        height: 37px !important;
        background-color: #333333 !important;
        color: #FFFFFF !important;
        font-size: 15px;
        font-weight: 500;
    }

    .plan-save-budget-modal-data-table thead th:first-child {
        border-radius: 10px 0 0 0;
    }

    .plan-save-budget-modal-data-table thead th:last-child {
        border-radius: 0 10px 0 0;
    }

    .plan-save-budget-modal-data-table thead th {
        font-size: 15px !important;
        font-weight: 500;
    }

    .plan-save-budget-modal-data-table.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .plan-save-budget-modal-data-table .v-data-table__wrapper table tbody tr td {
        padding-top: 0px;
        height: 25px !important;
    }

    .plan-save-budget-modal-data-table tbody tr td {
        border-bottom: 0px !important;
    }

    .plan-save-budget-modal-data-table tbody tr td:first-child {
        border-left: 0px !important;
        border-bottom: 0px !important;
    }

    .plan-save-budget-modal-data-table tbody tr td:last-child {
        border-right: 0px !important;
        border-bottom: 0px !important;
    }

    .plan-save-budget-modal-data-table tbody tr:nth-of-type(even) {
        background: #F5F5F5;
    }

    .search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .plan-save-budget-modal-data-table .v-data-table__wrapper table tbody tr td {
        border-left: none !important;
    }

    .plan-save-budget-modal-data-table.v-data-table > .v-data-table__wrapper {
        max-height: calc(100vh - 377px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .plan-save-budget-modal-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .plan-save-budget-modal-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .plan-save-budget-modal-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F8F5F5;
    }

    .plan-save-budget-modal-data-table.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
        min-height: 30px;
    }

    .plan-save-budget-modal-data-table.v-data-table--mobile > .v-data-table__wrapper tbody {
        display: flex;
        flex-direction: column;
        border: 1px solid #F5F5F5;
    }

    .v-input.slim > .v-input__control > .v-input__slot {
        min-height: auto;
    }

    .centered-input input {
        text-align: center
    }

    .text-field-plan-save-budget-table > .v-input__control > .v-input__slot {
        min-height: auto;
        width: 150px;
    }

    .text-field-plan-save-budget-table > .v-input__control {
        display: flex;
        align-content: center;
    }

    .text-field-plan-save-budget-table {
        font-size: 14px;
    }

    .text-field-plan-save-budget-table input {
        text-align: center
    }

    .radio-btn-plan-save-budget-modal .v-input--selection-controls__input i {
        font-size: 14px;
    }

    .radio-btn-plan-save-budget-modal .v-input--selection-controls__input .v-input--selection-controls__ripple {
        height: 20px;
        width: 20px;
        left: -5px;
        top: calc(50% - 17px);
    }

    .radio-btn-plan-save-budget-modal {
        color: black;
        font-weight: 500;
        font-size: 14px;
    }

    .radio-btn-plan-save-budget-modal .v-input--selection-controls__input {
        margin-right: 0px;
    }

    .font-size-16 {
        font-size: 16px;
        font-weight: 500;
    }

    @media only screen and (max-width:600px) {
        .plan-save-budget-header-modal {
            padding: 0px 20px;
        }

        .plan-save-budget-for-scroll-mobile {
            overflow-y: auto;
            border-radius: 0px;
            max-height: calc(100vh - 100px);
        }

        .plan-save-budget-modal-data-table.v-data-table > .v-data-table__wrapper {
            max-height: calc(100vh - 473px) !important;
        }
    }
</style>